import ptTranslation from './pt.json'
import enTranslation from './en.json'
import esTranslation from './es.json'

export default {
  pt: { translation: ptTranslation },
  en: { translation: enTranslation },
  es: { translation: esTranslation },
}
